// src/screens/ProfileMenuScreen.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useProfileContext } from '../context/ProfileContext';
import './ProfileMenuScreen.css';

import backIcon from '../assets/backspace-icon.png';
import dashboardIcon from '../assets/dashboard-icon.png';
import editIcon from '../assets/edit-icon.png';
import savedIcon from '../assets/save-icon-filled.png';
import mywalletIcon from '../assets/mywallet-icon.png';
import settingsIcon from '../assets/settings-icon.png';
import deleteIcon from '../assets/delete-icon.png';
import logoutIcon from '../assets/logout-icon.png';

const ProfileMenuScreen = ({ onLogout }) => {
  const navigate = useNavigate();
  const { clearProfileState } = useProfileContext();

  const handleDeleteAccount = () => {
    const confirmed = window.confirm(
      '⚠️ Are you sure you want to delete your BarterFi account? This cannot be undone.'
    );

    if (confirmed) {
      alert('🧼 Account deletion is a future feature. For now, please contact support.');
    }
  };

  const handleLogout = () => {
    clearProfileState();

    if (typeof onLogout === 'function') {
      onLogout();
    }

    navigate('/', { replace: true });
  };

  const menuItems = [
    {
      icon: dashboardIcon,
      label: 'Dashboard',
      subtitle: 'View your creator analytics',
      onClick: () => navigate('/analytics', { state: { from: 'profile' } }),
    },
    {
      icon: editIcon,
      label: 'Edit Profile',
      subtitle: 'Update your profile details',
      onClick: () => navigate('/edit-profile'),
    },
    {
      icon: savedIcon,
      label: 'Saved Posts',
      subtitle: 'Posts you saved for later',
      onClick: () => navigate('/saved'),
    },
    {
      icon: mywalletIcon,
      label: 'My Wallet',
      subtitle: 'Manage your BarterFi wallet',
      onClick: () => navigate('/my-wallet'),
    },
    {
      icon: settingsIcon,
      label: 'Settings',
      subtitle: 'Privacy and account settings',
      onClick: () => navigate('/settings'),
    },
    {
      icon: deleteIcon,
      label: 'Delete Account',
      subtitle: 'Request account deletion',
      danger: true,
      onClick: handleDeleteAccount,
    },
    {
      icon: logoutIcon,
      label: 'Logout',
      subtitle: 'Sign out of this account',
      onClick: handleLogout,
    },
  ];

  return (
    <div className="profile-menu-screen">
      <div className="profile-menu-topbar">
        <button
          className="profile-menu-back-btn"
          onClick={() => navigate('/profile')}
          aria-label="Go back"
        >
          <img src={backIcon} alt="Back" className="profile-menu-back-icon" />
        </button>

        <h2 className="profile-menu-title">Profile Menu</h2>

        <div className="profile-menu-topbar-spacer" />
      </div>

      <div className="profile-menu-content">
        <div className="profile-menu-header-card">
          <div className="profile-menu-header-title">Manage your account</div>
          <div className="profile-menu-header-subtitle">
            Quick access to your profile tools, wallet, settings, and account options.
          </div>
        </div>

        <div className="profile-menu-list">
          {menuItems.map((item) => (
            <button
              key={item.label}
              className={`profile-menu-item ${
                item.danger ? 'profile-menu-item-danger' : ''
              }`}
              onClick={item.onClick}
            >
              <div className="profile-menu-item-left">
                <div className="profile-menu-icon-wrap">
                  <img
                    src={item.icon}
                    alt=""
                    className="profile-menu-item-icon"
                  />
                </div>

                <div className="profile-menu-item-text">
                  <div className="profile-menu-item-label">{item.label}</div>
                  <div className="profile-menu-item-subtitle">{item.subtitle}</div>
                </div>
              </div>

              <span className="profile-menu-arrow">›</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileMenuScreen;
